import { useEffect, useState } from "react";
import {
    getUserSchedule,
    getMissingUserSchedule,
    updateUserTime,
    createUserTime,
} from "../../api/workingHoursApi";
import "./EditWorkingHoursModal.css";

export default function EditWorkingHoursModal({
                                                  userId,
                                                  onClose,
                                              }) {
    const [step, setStep] = useState(1);
    const [existing, setExisting] = useState([]);
    const [missing, setMissing] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadExisting();
    }, []);

    // STEP 1 DATA
    const loadExisting = async () => {
        const data =
            await getUserSchedule(userId);

        const formatted =
            (data || []).map((item) => ({
                id: item.id,
                name: item.week_day,
                entry: item.entry_time,
                leave: item.leave_time,
            }));

        setExisting(formatted);
    };

    // STEP 2 DATA
    const loadMissing = async () => {
        const data = await getMissingUserSchedule(userId);

        const formatted = data.map((item) => ({
            week_day_id: Number(item.id), // 🔥 id dan olamiz
            name: item.name,
            entry: "",
            leave: "",
            enabled: false,
        }));

        setMissing(formatted);
    };
    const goToAddStep = async () => {
        await loadMissing();
        setStep(2);
    };

    const updateExisting = (id, field, value) => {
        setExisting((prev) =>
            prev.map((item) =>
                item.id === id
                    ? { ...item, [field]: value }
                    : item
            )
        );
    };

    const updateMissing = (
        dayId,
        field,
        value
    ) => {
        setMissing((prev) =>
            prev.map((item) =>
                item.week_day_id === dayId
                    ? {
                        ...item,
                        [field]: value,
                    }
                    : item
            )
        );
    };

    const toggleMissing = (dayId) => {
        setMissing((prev) =>
            prev.map((item) =>
                item.week_day_id === dayId
                    ? {
                        ...item,
                        enabled:
                            !item.enabled,
                    }
                    : item
            )
        );
    };

    // UPDATE
    const handleUpdate = async () => {
        try {
            setLoading(true);

            await Promise.all(
                existing.map((item) =>
                    updateUserTime(item.id, {
                        entry_time:
                        item.entry,
                        leave_time:
                        item.leave,
                    })
                )
            );

            alert("Updated");
            onClose();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    // CREATE
    const handleCreate = async () => {
        try {
            setLoading(true);

            await Promise.all(
                missing
                    .filter((m) => m.enabled)
                    .map((item) =>
                        createUserTime({
                            user_id:
                            userId,
                            week_day_id:
                            item.week_day_id,
                            entry_time:
                            item.entry,
                            leave_time:
                            item.leave,
                        })
                    )
            );

            alert("Created");
            setStep(1);
            loadExisting();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="modal-overlay"
            onClick={onClose}
        >
            <div
                className="modal-large"
                onClick={(e) =>
                    e.stopPropagation()
                }
            >
                <div className="modal-header">
                    <h2>
                        Assign Working Hours
                    </h2>

                    {step === 1 && (
                        <button
                            className="secondary-btn"
                            onClick={
                                goToAddStep
                            }
                        >
                            + Add New
                        </button>
                    )}

                    {step === 2 && (
                        <button
                            className="secondary-btn"
                            onClick={() =>
                                setStep(1)
                            }
                        >
                            ← Back
                        </button>
                    )}
                </div>

                {step === 1 && (
                    <>
                        <div className="schedule-grid">
                            {existing.map(
                                (item) => (
                                    <div
                                        key={
                                            item.id
                                        }
                                        className="schedule-card"
                                    >
                                        <strong>
                                            {
                                                item.name
                                            }
                                        </strong>

                                        <div className="card-times">
                                            <input
                                                type="time"
                                                value={
                                                    item.entry
                                                }
                                                onChange={(
                                                    e
                                                ) =>
                                                    updateExisting(
                                                        item.id,
                                                        "entry",
                                                        e
                                                            .target
                                                            .value
                                                    )
                                                }
                                            />
                                            <input
                                                type="time"
                                                value={
                                                    item.leave
                                                }
                                                onChange={(
                                                    e
                                                ) =>
                                                    updateExisting(
                                                        item.id,
                                                        "leave",
                                                        e
                                                            .target
                                                            .value
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                )
                            )}
                        </div>

                        <button
                            className="save-btn-large"
                            onClick={
                                handleUpdate
                            }
                        >
                            Update Schedule
                        </button>
                    </>
                )}

                {step === 2 && (
                    <>
                        <div className="schedule-grid">
                            {missing.map(
                                (item) => (
                                    <div
                                        key={
                                            item.week_day_id
                                        }
                                        className="schedule-card"
                                    >
                                        <div className="card-header">
                                            <strong>
                                                {
                                                    item.name
                                                }
                                            </strong>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    checked={
                                                        item.enabled
                                                    }
                                                    onChange={() =>
                                                        toggleMissing(
                                                            item.week_day_id
                                                        )
                                                    }
                                                />
                                                Active
                                            </label>
                                        </div>

                                        {item.enabled && (
                                            <div className="card-times">
                                                <input
                                                    type="time"
                                                    value={
                                                        item.entry
                                                    }
                                                    onChange={(
                                                        e
                                                    ) =>
                                                        updateMissing(
                                                            item.week_day_id,
                                                            "entry",
                                                            e
                                                                .target
                                                                .value
                                                        )
                                                    }
                                                />
                                                <input
                                                    type="time"
                                                    value={
                                                        item.leave
                                                    }
                                                    onChange={(
                                                        e
                                                    ) =>
                                                        updateMissing(
                                                            item.week_day_id,
                                                            "leave",
                                                            e
                                                                .target
                                                                .value
                                                        )
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                )
                            )}
                        </div>

                        <button
                            className="save-btn-large"
                            onClick={
                                handleCreate
                            }
                        >
                            Save New Schedule
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}